<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Solicitar pago
        p.text-secondary.text-sm  Regresa una liga de pago generada para la orden actual.
        result-description.mb-3(variable-name="pago", variable-type="object")
        fieldset.mb-3(:disabled="disabled")
          b-form-group(label="Mensaje para solicitar el pago:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'mensaje'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Mensaje",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Referencia:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'reference'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Referencia",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Monto:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'amount'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Monto",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Promoción:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'promotions'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Promoción",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Restricción por tipo de tarjeta:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'cardblock'")
            vue-tribute(:options="tributeOpts")
              p.text-secondary.text-sm Sí se coloca el valor 'C' solo se permitirá el pago con tarjetas de crédito, sí se utiliza el valor 'D' únicamente se permitirá el pago con tarjetas de débito. (Dejar vacío para no aplicar ninguna restricción)    
              b-form-input.disabled-white(
                placeholder="Restricción por tipo de tarjeta (C o D)",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )                   
          b-form-group(label="Carrito de compra:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'order_items'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Carrito de compra",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="ID Credencial de pago:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'webPayCredentialId'")
            b-form-input.disabled-white(
              placeholder="ID Credencial de pago",
              :value="template_attribute.value",
              @blur="updateTemplateAttribute(template_attribute, $event)"
            )
          b-form-group(label="Plataforma de pago:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'paymentPlatform'")
            k-select.disabled-white(
              placeholder="- Seleccionar plataforma -",
              :options="platform_types",
              :disabled="disabled",
              :value="template_attribute.value || null",
              :searchable="false",
              @input="getPaymentPlatforms(template_attribute, $event)"
            )
          b-form-group(:label="`Cuenta de ${selected_platform_name}:`", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'payment_platform_id' && requiere_payment_id")
            k-select.disabled-white(
              placeholder="- Seleccionar plataforma -",
              :options="payment_platforms_accounts",
              :disabled="disabled",
              :value="template_attribute.value || null",
              :searchable="false",
              @input="updateTemplateAttribute(template_attribute, $event)",
            )
          b-form-group(label="Dirección de envío:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'shipping_address'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Dirección de envío",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Nombre de cliente:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'user_name'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Nombre de cliente",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Correo electrónico:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'email'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Correo",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Teléfono:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'phone'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Teléfono",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Guardar número de tarjeta:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'enrollment'")
            k-select.disabled-white(
              placeholder="- Seleccionar tipo -",
              :options="enrollment_types",
              :disabled="disabled",
              :value="template_attribute.value || null",
              :searchable="false",
              @input="updateTemplateAttribute(template_attribute, $event)"
            )
          p.text-secondary.text-sm Al habilitar esta opción no se envía de forma automática el 'Mensaje para solicitar el pago'
          result-description.mb-3(variable-name="payment_url", variable-type="object") 
          b-form-checkbox.mb-3(
            v-if="template_attribute.name === 'save_payment_url'",
            v-for="template_attribute in Template_Attributes",
            :key="template_attribute.template_attribute_id",
            switch,
            :checked="parseBoolean(template_attribute.value)",
            @change="updateTemplateAttribute(template_attribute, $event)"
          ) {{template_attribute.value ? 'Sí' : 'No' }} guardar link de pago          
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import templateCommon from '../../helpers/template-common'
import Connector from './connectors/Connector.vue'
import TemplateTools from './common/Tools.vue'
import ResultDescription from './helpers/ResultDescription'
import _debounce from 'lodash.debounce'
import { mapActions } from 'vuex'

export default {
  mixins: [templateCommon],
  data () {
    return {
      enrollment_types: [
        { label: 'Deshabilitado', id: 'disabled' },
        { label: 'Automático', id: 'auto' },
        { label: 'Mostrar checkbox', id: 'manual' },
      ],
      platform_types: [
        { label: 'Praga', id: 'Praga' },
        { label: 'Centro de Pago', id: 'CentroDePago' },
        { label: 'Stripe', id: 'Stripe' },
        { label: 'Paypal', id: 'Paypal' },
        { label: 'Payu', id: 'Payu' },
        { label: 'Epayco', id: 'Epayco' },
        { label: 'Conekta', id: 'Conekta' },
        { label: 'Fiserv', id: 'Fiserv' },
        { label: 'Niubiz', id: 'Niubiz' }
      ],
      selected_platform_name: '',
      payment_platforms_accounts: []
    }
  },
  computed: {
    requiere_payment_id () {
      let attr_template = this.getAttribute('paymentPlatform')
      return attr_template && (attr_template.value === 'Stripe' || attr_template.value === 'Paypal')
    }
  },
  methods: {
    ...mapActions(['account/stripe', 'account/paypal']),
    getPaymentPlatforms (template_attribute, value) {
      this.selected_platform_name = value
      this.payment_platforms_accounts = []
      template_attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, template_attribute)
      let attr_template = this.getAttribute('payment_platform_id')
      if (attr_template) {
        this.updateTemplateAttribute(attr_template, null)
      }
      if(value === "Stripe" || value === "Paypal") {
        this.getPaymentAccounts(value)
      }
    },
    async getPaymentAccounts (value) {
      value = value.toLowerCase()
      let self = this
      this['account/' + value]({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let names = {
              stripe: "public_key",
              paypal: "name"
            }
            this.payment_platforms_accounts = res.resource.map(el => {
              return {
                id: el[`${value}_id`],
                label: el[names[value]]
              }
            })
          }
        }
      })
    }
  },
  components: {
    'template-connector': Connector,
    TemplateTools,
    ResultDescription,
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId) => {
      if (collapseId === `advance_search_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
    let attr_template = this.getAttribute('paymentPlatform')
    if(attr_template &&  (attr_template.value === 'Stripe' || attr_template.value === 'Paypal')) {
      this.selected_platform_name = attr_template.value
      this.getPaymentAccounts(attr_template.value)
    }
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const attribute = JSON.parse(JSON.stringify(template_attribute))

      if (value && value.target) {
        attribute.value = value.target._value
      } else {
        attribute.value = value
      }

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>

</style>
